

    /**
     * Returns last element of array.
     */
    function last(arr){
        if (arr == null || arr.length < 1) {
            return undefined;
        }

        return arr[arr.length - 1];
    }

    module.exports = last;





//////////////////
// WEBPACK FOOTER
// ./~/mout/array/last.js
// module id = 1553
// module chunks = 0 1 2